/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Article } from '../../models/article';
import { CriteriaArticle } from '../../models/criteria-article';

export interface ApiMasterArticleGetByCriteriaPost$Params {
      body?: CriteriaArticle
}

export function apiMasterArticleGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterArticleGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Article>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterArticleGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Article>>;
    })
  );
}

apiMasterArticleGetByCriteriaPost.PATH = '/api/Master/Article/GetByCriteria';
